import type { PropsWithChildren } from 'react';
import { Box, Button, Text, useMediaQuery, VStack } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { CustomDesktopIcon } from '../theme/icons/CustomDesktopIcon';

// Routes that must remain reachable on any device (email-link actions, billing flows
// users may complete on mobile).
const ALLOWED_MOBILE_PATHS = [
  '/',
  '/confirm',
  '/email/confirm',
  '/my-account',
  '/subscription',
  '/login',
  '/error',
  '/dashboard',
  '/signup',
  '/account-settings',
  '/live-data',
  '/password-reset',
  '/forgot-password',
];

function DesktopResolutionGate({ children }: PropsWithChildren) {
  // 60em (960px) clears the 980px desktop-mode viewport that mobile browsers
  // use when the user requests the desktop site.
  const [isDesktop] = useMediaQuery('(min-width: 60em)');
  const { pathname } = useLocation();

  const isAllowedOnMobile = ALLOWED_MOBILE_PATHS.some(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  );

  return (
    <>
      {!isDesktop && !isAllowedOnMobile && (
        <Box
          position="fixed"
          inset={0}
          zIndex={1600}
          display="flex"
          alignItems="center"
          justifyContent="center"
          bg="white"
          px={6}
        >
          <VStack spacing={4} align="center">
            <CustomDesktopIcon boxSize="72px" flexShrink={0} color="gray.700" />
            <Text fontSize="xl" textAlign="center">
              Your resolution is too low
            </Text>
            <Text fontSize="md" textAlign="center">
              Please visit this page on a desktop device to continue.
            </Text>
            <Button as={RouterLink} to="/dashboard" mt={2}>
              Back to dashboard
            </Button>
          </VStack>
        </Box>
      )}
      {children}
    </>
  );
}

export default DesktopResolutionGate;
